import React from 'react';
import './TitleValue.less';

class TitleValue extends React.Component {

	render() {
        let values = '';
        const { title, value, capitalize = true } = this.props;
        if (Array.isArray(value)) {
            values = value;
        } else {
            values = [value];
        }
		return (
			<div className="title-value">
                <label className="title-value__title">{title}</label>
                {values.map((item, index) => <div key={index} className={`title-value__value${capitalize ? ' title-value__value--capitalize' : ''}`}>{capitalize ? item.toLowerCase() : item}</div>)}
            </div>
		);
	}
}

export default TitleValue;
